// Suppress third-party Chrome Extension errors (M_ID) from triggering CRA Dev Overlay
if (typeof window !== 'undefined') {
  const isExtensionErr = (text) => {
    if (!text) return false;
    const str = String(text);
    return (
      str.includes('M_ID') ||
      str.includes('chrome-extension://') ||
      str.includes('moz-extension://') ||
      str.includes('200.js') ||
      str.includes('FedCM') ||
      str.includes('eppiocemhmnlbhjplcgkofciiegomcon')
    );
  };

  // 1. Intercept console.error monitored by dev overlay
  const origConsoleError = console.error;
  console.error = (...args) => {
    const joined = args.map(a => (a && a.stack ? String(a) + ' ' + String(a.stack) : String(a || ''))).join(' ');
    if (isExtensionErr(joined)) {
      return;
    }
    if (origConsoleError) origConsoleError.apply(console, args);
  };

  // 2. Intercept Object.defineProperty window.onerror
  let _onerror = null;
  try {
    Object.defineProperty(window, 'onerror', {
      configurable: true,
      enumerable: true,
      get: () => _onerror,
      set: (fn) => {
        _onerror = (msg, url, line, col, error) => {
          const stack = error && error.stack;
          if (isExtensionErr(msg) || isExtensionErr(url) || isExtensionErr(stack)) {
            return true;
          }
          if (typeof fn === 'function') {
            return fn.apply(window, [msg, url, line, col, error]);
          }
          return false;
        };
      }
    });
  } catch (e) {}

  // 3. Capture event listeners
  const handleGlobalErr = (e) => {
    const msg = e?.message || e?.error?.message || '';
    const stack = e?.error?.stack || '';
    const filename = e?.filename || '';
    if (isExtensionErr(msg) || isExtensionErr(stack) || isExtensionErr(filename)) {
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (e.stopPropagation) e.stopPropagation();
      if (e.preventDefault) e.preventDefault();
      return true;
    }
  };

  window.addEventListener('error', handleGlobalErr, true);
  window.addEventListener('unhandledrejection', handleGlobalErr, true);

  // 4. Intercept React Error Overlay runtime error reporter hook
  window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ || {};
  const origReport = window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__.reportRuntimeError;
  window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__.reportRuntimeError = function(err) {
    const msg = err && (err.message || err.stack || String(err));
    if (isExtensionErr(msg)) {
      return;
    }
    if (origReport) origReport.apply(this, arguments);
  };

  // 5. DOM MutationObserver to auto-remove any error overlay iframe spawned by third-party extensions
  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node && node.nodeName === 'IFRAME') {
            setTimeout(() => {
              try {
                const content = (node.contentDocument && node.contentDocument.body && node.contentDocument.body.innerText) || '';
                if (isExtensionErr(content) || isExtensionErr(node.src)) {
                  node.remove();
                }
              } catch (err) {}
            }, 10);
          }
        });
      });
    });
    const startObserve = () => {
      if (document.body || document.documentElement) {
        observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startObserve);
    } else {
      startObserve();
    }
  }
}
